import { Stack } from "react-bootstrap";
import { Divider } from "antd";

export const FormActionsFooter = ({ children }) => {
  return (
    <Stack className="w-100 pb-4 sticky-bottom">
      <Divider />
      <div>{children}</div>
    </Stack>
  );
};
